import React from 'react';
import Condition, { ConditionProps } from './Condition';
import useConditionHelper from './conditionHelper';
import type { Filter } from '../FilterContext';
import { FilterCondition } from 'framework/types';

export const OR_CONDITION_TYPE = FilterCondition.OR;

const OrCondition = ({ children, onChangeCallback: parentOnchangeCallback, ...conditionProps }: ConditionProps) => {
  const { getValueFromCondition, buildValue } = useConditionHelper({
    ...conditionProps,
    conditionType: OR_CONDITION_TYPE,
  });

  const onChangeCallback = (value: Filter) => {
    const rawValue = getValueFromCondition(value);

    const result = buildValue(Array.isArray(rawValue) ? rawValue : [rawValue]);

    if (parentOnchangeCallback) {
      parentOnchangeCallback(result);
    }
  };

  return (
    <Condition {...conditionProps} conditionType={OR_CONDITION_TYPE} onChangeCallback={onChangeCallback}>
      {children}
    </Condition>
  );
};

export default OrCondition;
